<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formItemProduto from '@/src/components/form-item-produto.vue'

import Service from '@/src/services/itens_produto'

import Praga from '@src/services/pragas'
import Cultura from '@src/services/culturas'
import Produto from '@src/services/produto'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formItemProduto },
  data() {
    return {
      selectedItemProdutoEquipamento: null,
      selectedCulture: [],
      cultures: [],
      mostraForm: true,
      itemProdutoEdit: {},
      itemProdutoReport: {},
      itens_produto: [],
      itens_produto_equipamento: [],
      itemProdutoFields: [
        {
          key: 'id_produto',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'id_cultura',
          label: 'Cultura',
          class: 'size-col-20',
        },
        {
          key: 'id_pragas',
          label: 'Alvo',
          class: 'size-col-20',
        },
        {
          key: 'id_tipo_aplicacao',
          label: 'Tipo Aplicação',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      equipamentosItemProdutoFields: [
        {
          key: 'nomeProduto',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'nomeCultura',
          label: 'Cultura',
          class: 'size-col-20',
        },
        {
          key: 'nomePraga',
          label: 'Alvo',
          class: 'size-col-20',
        },
        {
          key: 'tipoAplicacao',
          label: 'Tipo Aplicação',
          class: 'size-col-20',
        },
        { key: 'manual', label: 'Pulverizadores manuais', class: 'size-col-10' },
        { key: 'costal', label: 'Pulverização costal', class: 'size-col-10' },
        { key: 'tratorizado', label: 'Pulverizador tratorizado', class: 'size-col-10' },
        { key: 'tratorizado_barra', label: 'Pulverização tratorizada com barra', class: 'size-col-10' },
        { key: 'aerea', label: 'Aplicação Aérea', class: 'size-col-10' },
        { key: 'drone', label: 'Aplicação ARP (Drones)', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
      rows: 0,
      pragas: [],
      produtos: [],
      culturas: [],
      filter: {
        id_pragas: '',
        id_cultura: '',
        id_produto: '',
      },
    }
  },
  computed: {
    filteredItems() {
      if (this.selectedCulture.includes(null) || this.selectedCulture.length === 0) {
        return this.itens_produto_equipamento;
      }
      return this.itens_produto_equipamento.filter(item =>
        this.selectedCulture.includes(item.nomeCultura)
      );
    }
  },

  watch: {
    currentPage() {
      this.listar()
    },
  },
  mounted() {
    this.listar()
    this.handleGet()
  },
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      console.log(this.filter)
      if (
        this.filter.id_pragas === '' &&
        this.filter.id_cultura === '' &&
        this.filter.id_produto === ''
      ) {
        Service.listar(token, this.perPage, this.currentPage).then(
          (resposta) => {
            this.itens_produto = resposta.data.dados
            this.rows = resposta.headers['x-total-count']
            this.isLoading = this.loading(this.isLoading)
          }
        )
      } else {
        Service.listar(
          token,
          this.perPage,
          this.currentPage,
          JSON.stringify(this.filter)
        ).then((resposta) => {
          this.itens_produto = resposta.data.dados
          this.rows = resposta.headers['x-total-count']
          this.isLoading = this.loading(this.isLoading)

          this.itens_produto_equipamento = [];

          // Loop through the fetched data to create a new list
          this.itens_produto.forEach(item => {
            const modifiedItem = {
              id: item.id_item_produto,
              nomeProduto: item.id_produto ? item.id_produto.nome : 'Produto não encontrado',
              nomeCultura: item.id_cultura ? item.id_cultura.nome_comum : 'Cultura não encontrada',
              nomePraga: item.id_pragas ? item.id_pragas.nome_comum : 'Praga não encontrada',
              tipoAplicacao: item.id_tipo_aplicacao ? item.id_tipo_aplicacao.nome : 'Tipo de aplicação não encontrado',
              manual: false,
              costal: false,
              tratorizado: false,
              tratorizadoBarra: false,
              aerea: false,
              drone: false,
              manualCaldaMin: item.volume_calda_min,
              manualCaldaMax: item.volume_calda,
              costalCaldaMin: item.volume_calda_min,
              costalCaldaMax: item.volume_calda,
              tratorizadoCaldaMin: item.volume_calda_min,
              tratorizadoCaldaMax: item.volume_calda,
              tratorizadoBarraCaldaMin: item.volume_calda_min,
              tratorizadoBarraCaldaMax: item.volume_calda,
              aereaCaldaMin: '',
              aereaCaldaMax: '',
              droneCaldaMin: '',
              droneCaldaMax: '',
              volume_calda: item.volume_calda,
              volume_calda_min: item.volume_calda_min,
            };

            // Add the modified item to the newData array
            this.itens_produto_equipamento.push(modifiedItem);
            this.cultures.push({ value: modifiedItem.nomeCultura, text: modifiedItem.nomeCultura })

          });
        })
      }
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      Praga.listar(token).then((response) => {
        this.pragas = response.data.dados
      })
      Produto.listar(token).then((response) => {
        this.produtos = response.data.dados
      })
      Cultura.listar(token).then((response) => {
        this.culturas = response.data.dados
      })
    },
    editRegister(item) {
      this.itemProdutoEdit = {
        id_item_produto: item.id_item_produto,
        aplic_area: item.aplic_area,
        ativo: item.ativo,
        desc_dose: item.desc_dose,
        desc_modo_aplicacao: item.desc_modo_aplicacao,
        desc_volume_calda: item.desc_volume_calda,
        dose_max: item.dose_max,
        dose_min: item.dose_min,
        id_cultura: item.id_cultura ? item.id_cultura.id_cultura : '',
        id_epoca_alvo: item.id_epoca_alvo,
        id_epoca_praga: item.id_epoca_praga,
        id_local_aplicacao: item.id_local_aplicacao,
        id_pragas: item.id_pragas ? item.id_pragas.id_pragas : '',
        id_produto: item.id_produto ? item.id_produto.id_produto : '',
        id_tipo_aplicacao: item.id_tipo_aplicacao.id_tipo_aplicacao,
        id_unidade: item.id_unidade,
        id_unidade_aplic: item.id_unidade_aplic,
        intervalo_seguranca: item.intervalo_seguranca,
        numero_aplicacoes_max: item.numero_aplicacoes_max,
        numero_aplicacoes_min: item.numero_aplicacoes_min,
        volume_calda: item.volume_calda,
        volume_calda_min: item.volume_calda_min,
      }
      this.mostraForm = false
    },
    copyRegister(item) {
      this.itemProdutoEdit = {
        aplic_area: item.aplic_area,
        ativo: item.ativo,
        desc_dose: item.desc_dose,
        desc_modo_aplicacao: item.desc_modo_aplicacao,
        desc_volume_calda: item.desc_volume_calda,
        dose_max: item.dose_max,
        dose_min: item.dose_min,
        id_cultura: item.id_cultura ? item.id_cultura.id_cultura : '',
        id_epoca_alvo: item.id_epoca_alvo,
        id_epoca_praga: item.id_epoca_praga,
        id_local_aplicacao: item.id_local_aplicacao,
        id_pragas: item.id_pragas ? item.id_pragas.id_pragas : '',
        id_produto: item.id_produto ? item.id_produto.id_produto : '',
        id_tipo_aplicacao: item.id_tipo_aplicacao.id_tipo_aplicacao,
        id_unidade: item.id_unidade,
        id_unidade_aplic: item.id_unidade_aplic,
        intervalo_seguranca: item.intervalo_seguranca,
        numero_aplicacoes_max: item.numero_aplicacoes_max,
        numero_aplicacoes_min: item.numero_aplicacoes_min,
        volume_calda: item.volume_calda,
        volume_calda_min: item.volume_calda_min,
      }
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Service.salvar(token, this.itemProdutoEdit)
        .then((resposta) => {
          this.listar()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.itemProdutoEdit = null
    },
    showReport(item) {
      this.itemProdutoReport = item
      this.$bvModal.show('modal-report')
    },
    cadastra() {
      if (this.itemProdutoEdit) {
        this.itemProdutoEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    Deletar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Service.deletar(token, this.idProduto)
        .then((resposta) => {
          this.listar()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
    saveEquipamentos() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      console.log(this.filteredItems);
      Service.salvarEquipament(token, this.filteredItems)
        .then((resposta) => {
          this.isLoading = false
          this.$bvModal.hide('modal-create-equipament')
          this.$bvToast.toast('Equipamentos criados com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listar()
        })
        .catch((err) => {
          this.isLoading = false
          this.$bvToast.toast(
            'Ocorreu um erro ao salvar equipamentos',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    }
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Relações</div>
            <div class="subTitulo">Visualize, edite e cadastre novas relações na plataforma.</div>
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Lista</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row" v-if="mostraForm">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Produto" label-for="filter">
              <v-select class="style-select" label="nome" :options="produtos" :reduce="(item) => item.id_produto"
                v-model="filter.id_produto" :dense="true"></v-select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Culturas" label-for="filter">
              <v-select class="style-select" label="nome_comum" :options="culturas" :reduce="(item) => item.id_cultura"
                v-model="filter.id_cultura"></v-select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Alvo" label-for="filter">
              <v-select class="style-select" label="nome_comum" :options="pragas" :reduce="(item) => item.id_pragas"
                v-model="filter.id_pragas"></v-select>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <button class="btn btn-webreceita" @click.prevent="listar">Filtrar</button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-webreceita" @click="$bvModal.show('modal-create-equipament')">
              <span>Adicionar Equipamento</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <b-table striped hover responsive="sm" borderless bordered outlined small :items="itens_produto"
            :fields="itemProdutoFields" :per-page="perPage">
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button v-b-tooltip.hover title="Consultar" type="button" class="btn btn-light"
                  @click="showReport(row.item)">
                  <i class="uil uil-search"></i>
                </button>
                <button v-b-tooltip.hover title="Editar" type="button" class="btn btn-light"
                  @click="editRegister(row.item)">
                  <i class="uil uil-edit"></i>
                </button>
                <button v-b-tooltip.hover title="Copiar" type="button" class="btn btn-light"
                  @click="copyRegister(row.item)">
                  <i class="uil uil-copy"></i>
                </button>
                <button v-b-tooltip.hover title="Deletar" type="button" class="btn btn-light"
                  @click="modalDelete(row.item.id_item_produto)">
                  <i class="uil uil-trash-alt"></i>
                </button>
                <button v-b-tooltip.hover title="Deletar" type="button" class="btn btn-light"
                  @click="modalDelete(row.item.id_item_produto)">
                  Ver bula
                </button>
              </div>
            </template>
            <template v-slot:cell(ativo)="row">{{
              row.item.ativo ? 'Sim' : 'Não'
            }}</template>
            <template #cell(id_produto)="row">{{
              row.item.id_produto
                ? row.item.id_produto.nome
                : 'Não encontrado'
            }}
              - M.A.P.A
              {{
                row.item.id_produto
                  ? row.item.id_produto.mapa
                  : 'Não encontrado'
              }}</template>
            <template #cell(id_cultura)="row">{{
              row.item.id_cultura
                ? row.item.id_cultura.nome_comum
                : 'Não encontrado'
            }}
              -
              {{
                row.item.id_cultura
                  ? row.item.id_cultura.nome_cientifico
                  : 'Não encontrado'
              }}</template>
            <template #cell(id_pragas)="row">{{
              row.item.id_pragas
                ? row.item.id_pragas.nome_comum
                : 'Não encontrado'
            }}
              -
              {{
                row.item.id_pragas
                  ? row.item.id_pragas.nome_cientifico
                  : 'Não encontrado'
              }}</template>
            <template #cell(id_tipo_aplicacao)="row">{{
              row.item.id_tipo_aplicacao
                ? row.item.id_tipo_aplicacao.nome
                : 'Não encontrado'
            }}
            </template>
          </b-table>
          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
        </div>

        <div v-else>
          <formItemProduto :item_produto="itemProdutoEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. dose" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_dose }}</span>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')">Não</b-button>
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>

    <b-modal v-if="this.itemProdutoReport.id_produto != null" size="lg" id="modal-report" title="Resumo da Relação"
      title-class="font-18">
      <div class="row">
        <div class="col-4">
          <b-form-group id="input-group-3" label="Produto" label-for="input-3">
            <span>{{ this.itemProdutoReport.id_produto.nome }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Cultura" label-for="input-3">
            <span>{{ this.itemProdutoReport.id_cultura.nome_comum }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Alvo" label-for="input-3">
            <span>{{ this.itemProdutoReport.id_pragas.nome_comum }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <b-form-group id="input-group-3" label="Dose mínima" label-for="input-3">
            <span>{{ this.itemProdutoReport.dose_min }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Dose máxima" label-for="input-3">
            <span>{{ this.itemProdutoReport.dose_max }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Volume de calda" label-for="input-3">
            <span>{{ this.itemProdutoReport.volume_calda }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <b-form-group id="input-group-3" label="Aplicação mínima" label-for="input-3">
            <span>{{ this.itemProdutoReport.numero_aplicacoes_min }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Aplicação máxima" label-for="input-3">
            <span>{{ this.itemProdutoReport.numero_aplicacoes_max }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Intervalo de segurança" label-for="input-3">
            <span>{{ this.itemProdutoReport.intervalo_seguranca }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. dose" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_dose }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. Modo de aplicação" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_modo_aplicacao }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. Volume Calda" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_volume_calda }}</span>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-report')">Ok</b-button>
      </template>
    </b-modal>

    <b-modal size="xl" id="modal-create-equipament" title="Adicionar Equipamentos de Aplicação" title-class="font-18">
      <div class="row">
        <b-form-select v-model="selectedCulture" multiple :select-size="4">
          <b-form-select-option :value="null">Todos</b-form-select-option>
          <b-form-select-option v-for="culture in cultures" :key="culture.value" :value="culture.value">
            {{ culture.value }}
          </b-form-select-option>
        </b-form-select>

        <div class="col-12">
          <b-table striped hover :fields="equipamentosItemProdutoFields" :items="filteredItems">
            <template #cell(nomeProduto)="row">{{
              row.item.nomeProduto
                ? row.item.nomeProduto
                : 'Não encontrado'
            }}
            </template>
            <template #cell(nomeCultura)="row">{{
              row.item.nomeCultura
                ? row.item.nomeCultura
                : 'Não encontrado'
            }}</template>
            <template #cell(nomePraga)="row">{{
              row.item.nomePraga
                ? row.item.nomePraga
                : 'Não encontrado'
            }}</template>

            <template #cell(tipoAplicacao)="row">{{
              row.item.tipoAplicacao
                ? row.item.tipoAplicacao
                : 'Não encontrado'
            }}</template>

            <template #cell(manual)="row">
              <b-form-checkbox v-model="row.item.manual" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.manual === 'true'" v-model="row.item.manualCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.manual === 'true'" v-model="row.item.manualCaldaMax" placeholder="Calda Max"
                class="mt-2"></b-form-input>
            </template>

            <template #cell(costal)="row">
              <b-form-checkbox v-model="row.item.costal" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.costal === 'true'" v-model="row.item.costalCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.costal === 'true'" v-model="row.item.costalCaldaMax" placeholder="Calda max"
                class="mt-2"></b-form-input>
            </template>

            <template #cell(tratorizado)="row">
              <b-form-checkbox v-model="row.item.tratorizado" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.tratorizado === 'true'" v-model="row.item.tratorizadoCaldaMin"
                placeholder="Calda Min" class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.tratorizado === 'true'" v-model="row.item.tratorizadoCaldaMax"
                placeholder="Calda Max" class="mt-2"></b-form-input>
            </template>

            <template #cell(tratorizado_barra)="row">
              <b-form-checkbox v-model="row.item.tratorizadoBarra" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.tratorizadoBarra === 'true'" v-model="row.item.tratorizadoBarraCaldaMin"
                placeholder="Calda Min" class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.tratorizadoBarra === 'true'" v-model="row.item.tratorizadoBarraCaldaMax"
                placeholder="Calda Max" class="mt-2"></b-form-input>
            </template>

            <template #cell(aerea)="row">
              <b-form-checkbox v-model="row.item.aerea" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.aerea === 'true'" v-model="row.item.aereaCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.aerea === 'true'" v-model="row.item.aereaCaldaMax" placeholder="Calda Max"
                class="mt-2"></b-form-input>
            </template>

            <template #cell(drone)="row">
              <b-form-checkbox v-model="row.item.drone" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.drone === 'true'" v-model="row.item.droneCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.drone === 'true'" v-model="row.item.droneCaldaMax" placeholder="Calda Max"
                class="mt-2"></b-form-input>

            </template>
          </b-table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-create-equipament')">Não</b-button>
        <b-button variant="danger" @click="saveEquipamentos()">Sim</b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>